import React from 'react'

import InviteReferralPartnerEmailPreview from '@/components/modals/InviteReferralPartnerEmailPreview'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

const PreviewInviteButton: React.FC = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link" className="p-0">
          Preview invite
        </Button>
      </DialogTrigger>

      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Preview of invitation email</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <InviteReferralPartnerEmailPreview />
        </DialogBody>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline-secondary">Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PreviewInviteButton
